module.exports = [{"filename":"About","displayName":"About us"},{"filename":"BlogPost","displayName":"Blog post"},{"filename":"NewsPost","displayName":"News post"},{"filename":"NewsList","displayName":"News list","createNestedRoute":true},{"filename":"Services","displayName":"Services"},{"filename":"Documentation","displayName":"Documentation"}]


//////////////////
// WEBPACK FOOTER
// ./src/app/templates/templates.json
// module id = soXp
// module chunks = 2